const APP_ENV = process.env.APP_ENV;
const INVITED_BASE_URL =
  APP_ENV === "prod" || APP_ENV === "stg"
    ? `https://${process.env.HOST_NAME}`
    : `http://${process.env.HOST_NAME}`;

const INVITED_APP_BASE_URL =
  APP_ENV === "prod" || APP_ENV === "stg"
    ? `https://${process.env.HOST_NAME}`
    : `http://${process.env.PARCEL_HOST_NAME}`;

const CASTLE_BASE_URL =
  APP_ENV === "prod" || APP_ENV === "stg"
    ? `wss://castle.${process.env.HOST_NAME}`
    : `ws://castle.${process.env.HOST_NAME}`;

export {APP_ENV, INVITED_BASE_URL, INVITED_APP_BASE_URL, CASTLE_BASE_URL };
